import React from 'react';
import PropTypes from 'prop-types';
import { buildThumbnailUrl } from '@bd/bdcore-utilities';
import LightBox from '@bd/bdui-lightbox';
import { get } from 'lodash';
import { css } from '@bd/bdui-styles/emotion';
import { colors } from '../../styles';

const styles = css`
  margin-bottom: 90px;
.PhotoList_list {
  list-style: none;
  display: flex;
  margin: 0;
  padding: 0;
  flex-flow: row wrap;
  justify-content: center;

  .PhotoList_item {
    list-style: none;
    margin: 0;
    padding: 0;
    width: 100%;
    cursor: pointer;
    margin-bottom: 20px;
    @media (min-width: 768px) {
      width: 46%;
      margin: 10px;
    }
    @media (min-width: 992px) {
      width: 31%;
      margin: 10px;
    }

    span {
      position: relative;
      display: block;
    }

    .PhotoList_imageTitle {
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      padding-top: 50%;
      width: 100%;
      z-index: 1;
      text-align: center;
      opacity: 0;
      transition: all 0.5s ease;
      background-color: rgba(63,63,63,.9);
      font-weight: 300;
      font-size: 24px;
      color: ${colors.white};
      z-index: 2;

      &:hover {
        opacity: 1;
      }

      &:after {
        content: '';
        width: 26px;
        height: 26px;
        background-image: url("/images/icon-plus.svg");
        position: absolute;
        display: block;
        top: calc(50% - 26px);
        left: 50%;
        margin-left: -13px;
      }
    }

    .PhotoList_image {
      position: relative;
      z-index: 0;
      width: 100%;
      padding-top: 75%;
      background-size: cover;
      background-position: center center;
      z-index: 1;
    }
    .PhotoList_image-vertical {
      position: relative;
      z-index: 0;
      width: 100%;
      padding-top: 130%;
      background-size: contain;
      background-position: center center;
      background-repeat: no-repeat;
      z-index: 1;
      border: 1px solid ${colors.whiteDarkest};
      background-color: #FFFFFF;
    }
  }
}
`;

const FloorPlans = ({ plan }) => {
  return (
    <div className={styles}>
      <div className="container">
        <LightBox items={get(plan, 'floorplanPhotos', [])} >
          <ul className="PhotoList_list">
            {
              get(plan, 'floorplanPhotos').map((photo, index) => {
                return (
                  <li className="PhotoList_item" key={photo.contentUrl} data-index={index}>
                    <span data-index={index}>
                      {
                        photo.caption &&
                        <div className="PhotoList_imageTitle" data-index={index}>
                          {photo.caption}
                        </div>
                      }
                      {
                        photo &&
                        <div className="PhotoList_image-vertical" style={{ backgroundImage: `url('${buildThumbnailUrl(photo.contentUrl, { width: 600, height: 600, preserve: true })}')` }} data-index={index} />
                      }
                    </span>
                  </li>
                );
              })
            }
          </ul>
        </LightBox>
      </div>
    </div>
  );
};

FloorPlans.propTypes = {
  plan: PropTypes.object.isRequired,
};

export default FloorPlans;



// WEBPACK FOOTER //
// ./src/pages/PlanDetail/FloorPlans.js